/* eslint-disable */
export default {
  title: 'Ääni',
  dialButtonVolume: 'Numeronvalintapainikkeen äänenvoimakkuus',
  ringtoneVolume: 'Soittoäänen voimakkuus',
  callVolume: 'Puhelun äänenvoimakkuus',
  muteCalls: 'Mykistä puhelut',
  outputDevice: 'Lähtölaite',
  inputDevice: 'Tulolaite',
  micPermission: 'Mikrofonin käyttölupa',
  noDevice: 'Ei laitteita',
  checkMicPermission: 'Tarkista käyttölupa',
  micNoPermissionMessage: 'Sovelluksella ei ole lupaa käyttää mikrofonia',
  noLabel: 'Tuntematon laite',
  notSetSinkIdTip:
    'Selaimen nykyiset käyttöluvat eivät anna palvelumme käyttää äänen lähtölaitteita. Katso, miten voit muokata asetuksia {clickHereLink}.',
  noLabelTip:
    'Selaimen nykyiset käyttöluvat eivät anna palvelumme käyttää äänen tulolaitteita.',
  clickHere: 'napsauttamalla tätä',
  defaultOutputDevice: 'Oletuslähtölaite',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
